import Translatable from "../translatable_text/Translatable";

type Props = {
  service: any
}

function Services( {service}: Props ) {

  return (
    <section className="services-details section-padding">
      <div className="w-full max-w-7xl mx-auto px-4">
        <div className="sec-head text-center mb-80">
          <div className="flex justify-center">
            <div className="w-full lg:w-2/3">
              <div>
                <h6 className="sub-title main-color mb-15">
                  <Translatable>
                    Web and Mobile Development
                  </Translatable>
                </h6>
                <h4>
                  <Translatable>
                    {service.desc}
                  </Translatable>
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-12 gap-6 serv-imgs mt-80 d-rotate wow">
          <div className="col-span-12 lg:col-span-4 flex flex-col items-center rotate-text">
            <div className="imgx w-92 o-hidden radius-15 fit-img md-mb30">
              <img className="" src={service.images[0]}  alt="img" loading="lazy"/>
            </div>
            <div className="downloads">
              <a
                href={service.downloads.ios.url}
                target='_blank'
                rel='noreferrer'
                className=" radius-30 main-colorbg mt-30x gap-4"
              >
                <span>
                  <Translatable>
                    Download
                  </Translatable>
                </span>
                <img className="download-img" src={service.downloads.ios.icon} alt="img" loading="lazy"/>
              </a>
              <a
                href={service.downloads.android.url}
                target='_blank'
                rel='noreferrer'
                className="radius-30 main-colorbg mt-30x gap-4"
              >
                <span>
                  <Translatable>
                    Download
                  </Translatable>
                </span>
                <img className="download-img" src={service.downloads.android.icon} alt="img" loading="lazy" />
              </a>
            </div>
          </div>
          
          <div className="col-span-12 lg:col-span-8 service-detail-img-container rotate-text">
            <video
              width="100%"
              preload="metadata"
              poster={service.images[1]}
              autoPlay
              playsInline
              muted
              loop
              className='radius-15'
            >
              <source src={service.vid} type="video/mp4" />
              <track
                src="subtitles.vtt"
                kind="subtitles"
                srcLang="en"
                label="English"
                default
              />
            </video>
            <div className="service-site-title">
              <a href={service.url} target='_blank' rel="noreferrer" className='border px-10 py-2 rounded-full'>Visit {service.title} Website</a>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-6 mt-80 details-advantages">
          <div className="col-span-12 lg:col-span-4">
            <div className="text md-mb50 ">
              <h5>
                <Translatable>
                  {service.competitiveAdvantage}
                </Translatable>
              </h5>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-8">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12 md:col-span-6">
                <ul className="rest list-arrow service-keypoints">
                  {service.keyPoints.map((point: any, i: number) => (
                    <li key={i} className="flex items-center gap-2">
                      <span className="icon">
                        <svg
                          width="100%"
                          height="100%"
                          viewBox="0 0 9 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M7.71108 3.78684L8.22361 4.29813L7.71263 4.80992L4.64672 7.87832L4.13433 7.36688L6.87531 4.62335H1.11181H0.750039H0.388177L0.382812 0.718232H1.10645L1.11082 3.90005H6.80113L4.12591 1.22972L4.63689 0.718262L7.71108 3.78684Z"
                            fill="#14cf93"
                          ></path>
                        </svg>
                      </span>
                      <h6 className="inlinex fw-400x">
                        <Translatable>
                          {point}
                        </Translatable>
                      </h6>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;
